module.exports = __webpack_public_path__ + "static/media/YM04_1.14c63b69.jpg";